/**
 * @desc 更新供应商公用合同模板
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierInfo.updateSupplierContractTemp.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/update/supplierContractTemp`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
